'use client';

import { useContext } from 'react';

import { AppContext } from './app-context-provider';

export function useAppContext() {
  const context = useContext(AppContext);

  if (!context) throw new Error('useAppContext must be use inside AppContextProvider');

  return context;
}
